import request from '@/api/axios'
import { apiList as api } from './apiList'

/**
 * 获取个人列表
 * @param {*} data
 * @returns
 */
export function getPersonals() {
  return request({
    url: api.home.evaluate.personals,
    method: 'get',
  })
}
/**
 * 获取可评价列表
 * @param {*} data
 * @returns
 */
export function getEvaluateList(query) {
  return request({
    url: api.home.evaluate.save,
    method: 'get',
    params: query,
  })
}

/**
 * 获取个人列表
 * @param {*} data
 * @returns
 */
export function getPersonalData() {
  return request({
    url: api.home.evaluate.personal,
    method: 'get',
  })
}
/**
 * 获取指标tree
 * @param {*} data
 * @returns
 */
export function getEvaluateTree(projectId) {
  return request({
    url: api.home.evaluate.evaluateTree + projectId + '/0',
    method: 'get',
  })
}
/**
 * 获取指标被评价次数
 * @param {*} data
 * @returns
 */
export function getEvaluateCount(params) {
  const { targetId, type, objectId } = params
  return request({
    url: api.home.evaluate.evaluateCount + `${targetId}/${type}/${objectId}`,
    method: 'get',
  })
}

/**
 * 提交验收
 * @param {*} data
 * @returns
 */
export function putEvaluateSubmit(data) {
  return request({
    url: api.home.evaluate.evaluateSubmit,
    method: 'put',
    data,
  })
}
/**
 * 获取评语列表
 * @param {*} data
 * @returns
 */
export function getQueryComments(targetId) {
  return request({
    url: api.home.evaluate.queryComments + targetId,
    method: 'get',
  })
}

/**
 * 删除评语
 * @param {} targetId
 * @returns
 */
export function deleteComments(targetId) {
  return request({
    url: api.home.evaluate.deleteComments + targetId,
    method: 'get',
  })
}
/**
 * 添加评语
 * @param {} params
 * @returns
 */
export function addComments(data) {
  return request({
    url: api.home.evaluate.addComments,
    method: 'post',
    data,
  })
}

/**
 * 应用前置检查
 */

export function checkPermission() {
  return request({
    url: api.home.evaluate.permissionCheck,
    method: 'get',
  })
}
/**
 * 获取用户信息
 * @param {*} data
 * @returns
 */
export function getEvaUserInfo() {
  return request({
    url: api.home.evaluate.evaUserInfo,
    method: 'get',
  })
}
